/**

 * This version emulates Java's 64-bit signed long overflow,
 * ensuring identical output to the original Java and Python implementations for hashing visitor id.
 */

const MASK_64_BIT = 0xffffffffffffffffn;
const MAX_SIGNED_64_BIT = 0x7fffffffffffffffn;

/**
 * Emulates Java's 'long' (64-bit signed) overflow semantics.
 * @param {bigint} bigint The number to wrap.
 * @returns {bigint} A 64-bit signed integer.
 */
function toSigned64(bigint) {
  // eslint-disable-next-line no-bitwise
  const wrapped = bigint & MASK_64_BIT;
  // If the sign bit (63rd bit) is set, subtract the range to get the negative value.
  return wrapped > MAX_SIGNED_64_BIT ? wrapped - (MASK_64_BIT + 1n) : wrapped;
}

/**
 * Hashes a string into a 64-bit BigInt, emulating Java's algorithm.
 * @param {string} uuid - The string to hash.
 * @returns {bigint} A 64-bit integer hash.
 */
function hashUUID(uuid) {
  let value = 1125899906842597n;
  const multiplier = 31n;

  uuid.split('').forEach(char => {
    // eslint-disable-next-line no-undef
    const charCode = BigInt(char.charCodeAt(0));
    value = toSigned64(multiplier * value + charCode);
  });

  return toSigned64(value);
}

/**
 * Generating hash based on visitor id.
 * @param {string} [visitorId]
 * @returns {bigint} The generated 64-bit ID.
 */
export function generateId(visitorId) {
  const id = visitorId;
  if (!id || id.trim() === '') {
    return 0n;
  }
  if (id.length < 8) {
    let value = 0n;
    const bytes = new TextEncoder().encode(id);
    bytes.forEach(byte => {
      // eslint-disable-next-line no-bitwise, no-undef
      value = toSigned64((value << 8n) + BigInt(byte));
    });
    return toSigned64(value);
  }
  return hashUUID(id);
}
